module.exports = __webpack_public_path__ + "static/img/left-check.bb118b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/left-check.png
// module id = fxc4
// module chunks = 1